import { Typography } from "@mui/material";
import React from "react";

export default function DividerView() {
  return (
    <Typography fontSize={"0.75rem"} color={"black"} fontWeight={500}>
      |
    </Typography>
  );
}
